interface AdminLayoutProps {
  children: React.ReactNode
}

/** Page-pane admin routes — padding comes from `PageContainer`; avoid double inset here. */
export function AdminLayout({ children }: AdminLayoutProps) {
  return <div className="flex flex-1 flex-col">{children}</div>
}
